import {Row} from "../row/row";

export class GroupRow {
  id: string;
  name: string;
  isCollapsed: boolean = false;
  rows: Row[] = [];
  rowDictionary: { [id: string]: Row } = {}
  isIndeterminate: boolean = false;
  isChecked: boolean = true;
  vat: number;
  revenue: number;
  soldUnits: number;
  netRevenue: number = 0
  sourceDetailCosts: number = 0

  constructor(id: string, name: string, rows: Row[], vat: number, revenue: number, soldUnits: number) {
    this.name = name;
    this.id = id;
    this.rows = rows;
    this.vat = vat;
    this.revenue = revenue;
    this.soldUnits = soldUnits;
  }

  static addRow(row: Row, groupRow: GroupRow): Row {
    groupRow.rowDictionary[row.id] = row
    groupRow.rows.push(row)
    return row
  }

  static getById(rowId: string, groupRow: GroupRow): Row {
    return groupRow.rowDictionary[rowId]
  }

  static hasId(id: string, groupRow: GroupRow): boolean {
    return groupRow.rowDictionary[id] !== undefined
  }
}
